import { render, staticRenderFns } from "./waitInvoicesList.vue?vue&type=template&id=536c8569&scoped=true"
import script from "./waitInvoicesList.vue?vue&type=script&lang=js"
export * from "./waitInvoicesList.vue?vue&type=script&lang=js"
import style0 from "./waitInvoicesList.vue?vue&type=style&index=0&id=536c8569&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536c8569",
  null
  
)

export default component.exports